import { render, staticRenderFns } from "./okOtherTry.vue?vue&type=template&id=8a3c2bdc&scoped=true&"
import script from "./okOtherTry.vue?vue&type=script&lang=js&"
export * from "./okOtherTry.vue?vue&type=script&lang=js&"
import style0 from "./okOtherTry.vue?vue&type=style&index=0&id=8a3c2bdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3c2bdc",
  null
  
)

export default component.exports